/* =========================================================================
 * Fitting Parts Popup
 * -------------------------------------------------------------------------
 * 1. Watches #assembly-list for items with class .facets__item and
 *    data-label="Fasteners" (case-insensitive). When found, injects a
 *    "View diagram" trigger link with a derived assembly_id.
 *
 * 2. On trigger click, opens the <fitting-parts-popup> modal and calls
 *    fetchDiagram(assembly_id). The fetch is currently mocked via
 *    fetchDiagram() — replace the body of that
 *    function with a real fetch() when the endpoint is ready.
 *
 * 3. Renders an interactive diagram with point/rect hotspots overlaid on a
 *    background image, plus a side list of products. Click on a hotspot
 *    scrolls the list to the matching product, highlights it, and opens a
 *    pinned product preview popup until closed or another part is selected.
 *
 * 4. Reads the live cart on open to pre-mark hotspots/list items that are
 *    already in the cart with a green check. Adds-to-cart through Shopify's
 *    /cart/add.js, then refreshes cart-icon-bubble and cart-drawer sections.
 * ========================================================================= */

(function () {
  "use strict";

  /* ------------------------------------------------------------------------ *
   * MOCK API — replace with real fetch when endpoint is available.
   * ------------------------------------------------------------------------ */
  // function buildMock(assemblyId) {
  //     let count = 14;
  //     let products = [];
  //     for (let i = 0; i < count; i++) {
  //         let idx = i + 1;
  //         products.push({
  //             id: 1000 + i,
  //             variant_id: 9000 + i,
  //             sku: "FP-" + String(idx).padStart(3, "0"),
  //             handle: "fitting-part-" + idx,
  //             title: "Fastener " + idx + " — M" + (4 + (i % 6)) + " bolt",
  //             price: 1499 + i * 200, // cents
  //             image: "https://placehold.co/120x120?text=F",
  //             featured_image: "https://placehold.co/120x120?text=F",
  //             url: "/products/fitting-part-" + idx,
  //         });
  //     }

  //     const hotspots = products.map(function (p, i) {
  //         // Place hotspots on a rough ellipse for the demo background.
  //         let angle = (i / count) * Math.PI * 2;
  //         let x = 0.5 + 0.32 * Math.cos(angle);
  //         let y = 0.5 + 0.28 * Math.sin(angle);

  //         // Every 4th hotspot is a rectangle, the rest are points.
  //         if (i % 4 === 0) {
  //             return {
  //                 type: "rect",
  //                 x_normalized: x - 0.05,
  //                 y_normalized: y - 0.04,
  //                 width_normalized: 0.1,
  //                 height_normalized: 0.08,
  //                 product_sku: p.sku,
  //             };
  //         }
  //         return {
  //             type: "point",
  //             x_normalized: x,
  //             y_normalized: y,
  //             radius_px: 14,
  //             product_sku: p.sku,
  //         };
  //     });

  //     return {
  //         assembly_id: assemblyId,
  //         hotspots: hotspots,
  //         background_image: "https://placehold.co/1000x700?text=Assembly+" + (assemblyId || "demo"),
  //         products_list: products,
  //     };
  // }

  /* ------------------------------------------------------------------------ *
   * Custom element: <fitting-parts-popup>
   * ------------------------------------------------------------------------ */

  let CHECK_SVG =
    '<svg viewBox="0 0 12 9" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M4.67 6.61L10.79.49l.94.94L4.67 8.5.42 4.26l.94-.94L4.67 6.61z"/></svg>';

  let REMOVE_SVG =
    '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>' +
    '<path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>' +
    "</svg>";

  class FittingPartsPopup extends HTMLElement {
    constructor() {
      super();
      this.firstInit = true;
    }

    connectedCallback() {
      if (!this.firstInit) return;
      this.firstInit = false;

      this.dialog = this.querySelector("[data-fp-dialog]");
      this.imageArea = this.querySelector("[data-fp-image-area]");
      this.imageWrapper = this.querySelector("[data-fp-image-wrapper]");
      this.image = this.querySelector("[data-fp-image]");
      this.hotspotsLayer = this.querySelector("[data-fp-hotspots]");
      this.tooltip = this.querySelector("[data-fp-tooltip]");
      this.callout = this.querySelector("[data-fp-callout]");
      this.list = this.querySelector("[data-fp-list]");
      this.countEl = this.querySelector("[data-fp-count]");
      this.titleEl = this.querySelector("[data-fp-title]");
      this.loader = this.querySelector("[data-fp-loader]");
      this.errorEl = this.querySelector("[data-fp-error]");
      this.closeBtn = this.querySelector("[data-fp-close]");
      this.overlay = this.querySelector("[data-fp-overlay]");
      this.zoomControls = this.querySelector("[data-fp-zoom-controls]");
      this.zoomInBtn = this.querySelector("[data-fp-zoom-in]");
      this.zoomOutBtn = this.querySelector("[data-fp-zoom-out]");
      this.zoomResetBtn = this.querySelector("[data-fp-zoom-reset]");
      this.searchInput = this.querySelector("[data-fp-search-input]");
      this.searchClear = this.querySelector("[data-fp-search-clear]");
      this.listEmpty = this.querySelector("[data-fp-list-empty]");
      this.listEmptyQuery = this.querySelector("[data-fp-list-empty-query]");
      this.listEmptyClearBtn = this.querySelector("[data-fp-list-empty-clear]");

      this.products = [];
      this.hotspots = [];
      this.cartKeys = new Set();
      this.cartLineKeys = new Map();
      this.activeIndex = -1;
      this.popupIndex = -1;
      this.lastActiveContext = null;
      this.searchQuery = "";
      this.calloutDismissed = false;
      this.productAssemblyId = "";
      this.productBrand = "";
      this.productModel = "";
      this.productSerialNumberRange = "";
      this.mockUrl = this.getAttribute("data-fp-mock-url") || "";
      this.zoom = 1;
      this.zoomMin = 1;
      this.zoomMax = 3;
      this.zoomStep = 0.25;
      this.baseImageWidth = 0;
      this.isDraggingZoom = false;
      this.zoomDragStartX = 0;
      this.zoomDragStartY = 0;
      this.zoomStartScrollLeft = 0;
      this.zoomStartScrollTop = 0;

      this._boundZoomDragMove = this._onZoomDragMove.bind(this);
      this._boundZoomDragEnd = this._onZoomDragEnd.bind(this);
      this._boundRepositionPopup = this._repositionPopupIfOpen.bind(this);
      this.debouncedSearch = debounce((event) => {
        this._applySearchFilter(event.target.value);
      }, 180);

      if (this.searchInput) {
        this.searchInput.addEventListener(
          "input",
          this.debouncedSearch.bind(this),
        );
        this.searchInput.addEventListener("input", () => {
          if (this.searchClear)
            this.searchClear.hidden = !this.searchInput.value;
        });
      }
      if (this.searchClear) {
        this.searchClear.addEventListener("click", () => this._clearSearch());
      }
      if (this.listEmptyClearBtn) {
        this.listEmptyClearBtn.addEventListener("click", () =>
          this._clearSearch(),
        );
      }

      this.closeBtn.addEventListener("click", this.close.bind(this));
      this.overlay.addEventListener("click", this.close.bind(this));
      if (this.zoomInBtn)
        this.zoomInBtn.addEventListener("click", () =>
          this._setZoom(this.zoom + this.zoomStep),
        );
      if (this.zoomOutBtn)
        this.zoomOutBtn.addEventListener("click", () =>
          this._setZoom(this.zoom - this.zoomStep),
        );
      if (this.zoomResetBtn)
        this.zoomResetBtn.addEventListener("click", () => this._setZoom(1));
      if (this.imageArea) {
        this.imageArea.addEventListener("scroll", () => {
          this._updateZoomControlsPosition();
          this._boundRepositionPopup();
        });
        this.imageArea.addEventListener(
          "mousedown",
          this._onZoomDragStart.bind(this),
        );
      }
      window.addEventListener("resize", () => {
        this._updateZoomControlsPosition();
        this._boundRepositionPopup();
      });
      if (this.tooltip) {
        this.tooltip.addEventListener("click", (e) => {
          if (e.target.closest && e.target.closest("[data-fp-popup-close]")) {
            e.stopPropagation();
            this._hidePopup();
          }
        });
      }
      if (this.callout) {
        this.callout.addEventListener("click", (e) => {
          if (e.target.closest && e.target.closest("[data-fp-callout-close]")) {
            e.stopPropagation();
            this._dismissCallout();
          }
        });
      }
      document.addEventListener("keydown", this._onKey.bind(this));
      document.addEventListener("click", this._onDocClick.bind(this));
    }

    fetchDiagram() {
      const url = this.mockUrl
        ? this.mockUrl
        : `https://api.groundsgear.com/proxy/diagram?b=${encodeURIComponent(this.productBrand)}&m=${encodeURIComponent(this.productModel)}&s=${encodeURIComponent(this.productSerialNumberRange)}&a=${encodeURIComponent(this.productAssemblyId)}`;
      return fetch(url)
        .then((r) => r.json())
        .catch(() => null);
    }

    _onKey(e) {
      if (e.key === "Escape" && this.isOpen()) this.close();
    }

    _onDocClick(e) {
      let trigger =
        e.target.closest && e.target.closest("[data-fitting-parts-trigger]");
      if (!trigger) return;
      e.preventDefault();
      this.productBrand = trigger.getAttribute("data-brand") || "";
      this.productModel = trigger.getAttribute("data-model") || "";
      this.productSerialNumberRange =
        trigger.getAttribute("data-serial-number-range") || "";
      this.productAssemblyId = trigger.getAttribute("data-assembly") || "";
      this.open();
    }

    isOpen() {
      return this.classList.contains("is-open");
    }

    async open() {
      this.setAttribute("aria-hidden", "false");
      this.classList.add("is-open");
      document.body.classList.add("fp-no-scroll");
      this._showLoader(true);
      this._showError(false);
      this._prepareZoomForNewImage();

      try {
        const [data, cartState] = await Promise.all([
          this.fetchDiagram(),
          this._fetchCartKeys(),
        ]);
        this.cartKeys = cartState.keys;
        this.cartLineKeys = cartState.lineKeys;
        if (!data) {
          this._showError(true);
          this._showLoader(false);
          return;
        }
        this._render(data);
      } catch (err) {
        console.error("[fitting-parts] open failed:", err);
        this._showError(true);
        this._showLoader(false);
      }
    }

    close() {
      this.classList.remove("is-open");
      this.setAttribute("aria-hidden", "true");
      document.body.classList.remove("fp-no-scroll");
      this._stopZoomDrag();
      // Hide the tooltip but keep the active hotspot ring / sidebar
      // highlight — one part stays visually selected after closing.
      if (this.tooltip) {
        this.popupIndex = -1;
        this.tooltip.classList.remove("is-visible");
        this.tooltip.setAttribute("aria-hidden", "true");
        this.tooltip.innerHTML = "";
      }
      this._resetSearchState();
    }

    /* ----- Rendering ----------------------------------------------------- */

    _render(data) {
      this._resetSearchState();
      this.products = Array.isArray(data?.products) ? data.products : [];
      this.hotspots = Array.isArray(data?.config?.hotspots)
        ? data.config.hotspots
        : [];
      this.hotspots = this.hotspots.map((h, i) => ({
        ...h,
        diagram_item: h.diagram_item ?? i + 1,
      }));
      if (this.titleEl) {
        this.titleEl.textContent = data.title || "Fitting parts diagram";
      }

      if (this.countEl) {
        this.countEl.textContent = String(this.products.length);
      }

      this._renderList();

      // Wait for the image to load so hotspots align correctly.
      const bg = data.image;
      if (!bg) {
        this._showError(true);
        this._showLoader(false);
        return;
      }
      this.image.onload = () => {
        this._initZoom();
        this._renderHotspots();
        this._showLoader(false);
      };
      this.image.onerror = () => {
        this._showError(true);
        this._showLoader(false);
      };
      this.image.src = bg;
    }

    _renderHotspots() {
      this.hotspotsLayer.innerHTML = "";
      this.activeIndex = -1;
      this.popupIndex = -1;
      this._hidePopup();

      this.hotspots.forEach((h, idx) => {
        let btn = document.createElement("button");
        btn.type = "button";
        btn.className =
          "fp-hotspot fp-hotspot--" + (h.type === "rect" ? "rect" : "point");
        btn.dataset.fpHotspot = String(idx);
        btn.dataset.sku = h.product_sku || "";
        const itemNum = h.diagram_item ?? idx + 1;
        let ariaLabel = "Part " + itemNum;
        if (h.diagram_description) ariaLabel += ": " + h.diagram_description;
        btn.setAttribute("aria-label", ariaLabel);

        if (h.type === "rect") {
          btn.style.left = pct(h.x_normalized);
          btn.style.top = pct(h.y_normalized);
          btn.style.width = pct(h.width_normalized);
          btn.style.height = pct(h.height_normalized);
        } else {
          btn.style.left = pct(h.x_normalized);
          btn.style.top = pct(h.y_normalized);
          const MIN_POINT_RADIUS_PERCENT = 0.009;
          const radiusPercent = Math.max(
            normalizeRadiusPercent(h.radius_percent),
            MIN_POINT_RADIUS_PERCENT,
          );
          btn.style.width = pct(radiusPercent * 2);
          btn.style.height = "auto";
        }

        const numberClass =
          "fp-hotspot__number" +
          (String(itemNum).length > 3 ? " fp-hotspot__number--long" : "");
        btn.innerHTML =
          '<span class="' +
          numberClass +
          '">' +
          itemNum +
          "</span>" +
          '<span class="fp-hotspot__check">' +
          CHECK_SVG +
          "</span>";

        let product = this._findProduct(h.product_sku);
        if (this._isInCart(product)) btn.classList.add("fp-hotspot--in-cart");

        btn.addEventListener("click", () => this._activateHotspot(idx));

        this.hotspotsLayer.appendChild(btn);
      });

      this._showCallout();
      this._restoreActiveState();
    }

    // Re-applies the ring/list highlight for the part the user last
    // selected in this same diagram, so it survives a close -> reopen
    // cycle instead of resetting on every fresh _render().
    _restoreActiveState() {
      const ctx = this.lastActiveContext;
      if (!ctx) return;
      const sameContext =
        ctx.brand === this.productBrand &&
        ctx.model === this.productModel &&
        ctx.serial === this.productSerialNumberRange &&
        ctx.assembly === this.productAssemblyId;
      if (!sameContext) return;

      const EPS = 0.001;
      const idx = this.hotspots.findIndex(
        (h) =>
          h.product_sku === ctx.sku &&
          Math.abs((h.x_normalized ?? 0) - ctx.x) < EPS &&
          Math.abs((h.y_normalized ?? 0) - ctx.y) < EPS,
      );
      if (idx === -1) return;

      this.activeIndex = idx;
      this._findRelatedHotspotIndices(idx).forEach((hotspotIdx) => {
        const hotspotEl = this.hotspotsLayer.querySelector(
          '[data-fp-hotspot="' + hotspotIdx + '"]',
        );
        if (hotspotEl) hotspotEl.classList.add("is-active");
      });
      const item = this._findListItemForHotspot(idx);
      if (item) item.classList.add("is-active");
    }

    _renderList() {
      this.list.innerHTML = "";
      this.products.forEach((p, idx) => {
        let productKeys = getProductKeys(p);
        let sku = p.sku || getVariantSku(p) || p.handle || "p" + idx;
        let li = document.createElement("li");
        li.className = "fp-product";
        li.dataset.sku = sku;
        li.dataset.productKeys = JSON.stringify(productKeys);

        if (this._isInCart(p)) li.classList.add("fp-product--in-cart");

        const inCart = this._isInCart(p);

        const hotspotIndices = this._findHotspotIndicesForProduct(p);
        const hotspotIdx = hotspotIndices[0];
        const diagramQty = this._getDiagramQtyForHotspots(hotspotIndices);

        if (hotspotIdx != null) {
          li.dataset.hotspotIdx = String(hotspotIdx);
          li.dataset.hotspotIdxs = JSON.stringify(hotspotIndices);
        }
        if (diagramQty > 1) li.dataset.diagramQty = String(diagramQty);
        li.dataset.fpSearchText = this._buildSearchText(p, hotspotIndices);

        const hotspotForIndex =
          hotspotIdx != null ? this.hotspots[hotspotIdx] : null;
        const displayIndex = hotspotForIndex
          ? hotspotForIndex.diagram_item
          : idx + 1;

        li.innerHTML =
          '<div class="fp-product__index">' +
          displayIndex +
          "</div>" +
          '<div class="fp-product__media">' +
          '<img src="' +
          esc(getImage(p)) +
          '" alt="' +
          esc(getTitle(p)) +
          '" loading="lazy">' +
          "</div>" +
          '<div class="fp-product__info">' +
          '<div class="fp-product__title">' +
          esc(getTitle(p)) +
          "</div>" +
          (p.sku
            ? '<div class="fp-product__sku">SKU: ' + esc(p.sku) + "</div>"
            : "") +
          (diagramQty > 1
            ? '<div class="fp-product__diagram-qty">Diagram QTY: ' +
              esc(diagramQty) +
              "</div>"
            : "") +
          '<div class="fp-product__price">' +
          formatPrice(p) +
          "</div>" +
          "</div>" +
          '<div class="fp-product__actions">' +
          this._buildProductActionsHTML(p, inCart) +
          '<span class="fp-product__check" aria-hidden="true">' +
          CHECK_SVG +
          "</span>" +
          "</div>" +
          '<div class="fp-product__error"></div>';

        this._bindQuantityControls(li);
        li.querySelector("[data-fp-add]").addEventListener("click", () =>
          this._addToCart(p, li),
        );
        const removeBtn = li.querySelector("[data-fp-remove]");
        if (removeBtn) {
          removeBtn.addEventListener("click", () =>
            this._removeFromCart(p, li),
          );
        }

        // Hover on a list item highlights every matching callout.
        li.addEventListener("mouseenter", () =>
          this._setHoveredHotspot(li.dataset.hotspotIdx),
        );
        li.addEventListener("mouseleave", () => this._setHoveredHotspot(null));
        li.addEventListener("click", (e) => {
          if (e.target.closest && e.target.closest(".fp-product__actions"))
            return;
          if (li.dataset.hotspotIdx) {
            this._activateHotspot(li.dataset.hotspotIdx);
          } else {
            this._activateListItemOnly(li);
          }
        });

        this.list.appendChild(li);
      });
    }

    _buildSearchText(product, hotspotIndices) {
      let parts = [
        getTitle(product),
        product.sku,
        getVariantSku(product),
        product.handle,
        product.vendor,
      ];
      (hotspotIndices || []).forEach((idx) => {
        let h = this.hotspots[idx];
        if (h && h.diagram_description) parts.push(h.diagram_description);
      });
      return parts.filter(Boolean).join(" ").toLowerCase();
    }

    /* ----- Search / filter ------------------------------------------------ */

    _applySearchFilter(query) {
      const normalized = String(query || "")
        .trim()
        .toLowerCase();
      this.searchQuery = normalized;

      let visibleCount = 0;
      const visibleHotspotIdxs = new Set();

      if (this.list) {
        this.list.querySelectorAll(".fp-product").forEach((li) => {
          const matches =
            !normalized ||
            (li.dataset.fpSearchText || "").indexOf(normalized) !== -1;
          li.hidden = !matches;
          if (matches) {
            visibleCount++;
            getDatasetHotspotIdxs(li).forEach((idx) =>
              visibleHotspotIdxs.add(idx),
            );
          }
        });
      }

      if (this.hotspotsLayer) {
        this.hotspotsLayer.querySelectorAll(".fp-hotspot").forEach((btn) => {
          const isFiltered =
            !!normalized && !visibleHotspotIdxs.has(btn.dataset.fpHotspot);
          btn.disabled = isFiltered;
        });
      }

      if (this.countEl) {
        this.countEl.textContent = normalized
          ? visibleCount + " of " + this.products.length
          : String(this.products.length);
      }

      const isEmpty = !!normalized && visibleCount === 0;
      if (this.list) this.list.hidden = isEmpty;
      if (this.listEmpty) this.listEmpty.hidden = !isEmpty;
      if (isEmpty && this.listEmptyQuery)
        this.listEmptyQuery.textContent = query.trim();

      if (this.activeIndex >= 0 && this.hotspotsLayer) {
        const activeHotspotEl = this.hotspotsLayer.querySelector(
          '[data-fp-hotspot="' + this.activeIndex + '"]',
        );
        if (activeHotspotEl && activeHotspotEl.disabled) {
          this.activeIndex = -1;
          this._hidePopup();
          this._clearHotspotRing();
        }
      }
    }

    _resetSearchState() {
      this.searchQuery = "";
      if (this.searchInput) this.searchInput.value = "";
      if (this.searchClear) this.searchClear.hidden = true;
      if (this.listEmpty) this.listEmpty.hidden = true;
      if (this.list) this.list.hidden = false;
    }

    _clearSearch() {
      this._resetSearchState();
      this._applySearchFilter("");
      if (this.searchInput) this.searchInput.focus();
    }

    /* ----- Interactions -------------------------------------------------- */

    _clearHotspotRing() {
      if (!this.hotspotsLayer) return;
      this.hotspotsLayer.querySelectorAll(".fp-hotspot").forEach(function (el) {
        el.classList.remove("is-active");
        el.style.outline = "";
        el.style.outlineOffset = "";
      });
    }

    _activateHotspot(idx) {
      console.log("active hotspot", idx);
      idx = Number(idx);
      this.activeIndex = idx;
      let hotspot = this.hotspots[idx];
      if (!hotspot) return;

      this.lastActiveContext = {
        brand: this.productBrand,
        model: this.productModel,
        serial: this.productSerialNumberRange,
        assembly: this.productAssemblyId,
        sku: hotspot.product_sku,
        x: hotspot.x_normalized,
        y: hotspot.y_normalized,
      };

      this._clearHotspotRing();
      this._findRelatedHotspotIndices(idx).forEach((hotspotIdx) => {
        let hotspotEl = this.hotspotsLayer.querySelector(
          '[data-fp-hotspot="' + hotspotIdx + '"]',
        );
        if (hotspotEl) hotspotEl.classList.add("is-active");
      });
      if (this.hotspotsLayer) void this.hotspotsLayer.offsetWidth;

      this.list.querySelectorAll(".fp-product").forEach(function (el) {
        el.classList.remove("is-active");
      });
      let item = this._findListItemForHotspot(idx);
      if (item) {
        item.classList.add("is-active");
        item.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      requestAnimationFrame(() => {
        this._showPopup(idx);
        requestAnimationFrame(() => {
          this._positionPopupByIndex(idx);
        });
      });
    }

    _activateListItemOnly(listItem) {
      this.activeIndex = -1;
      this._hidePopup();
      this._clearHotspotRing();

      this.list.querySelectorAll(".fp-product").forEach(function (el) {
        el.classList.remove("is-active");
      });
      listItem.classList.add("is-active");
      listItem.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    // Toggles `.is-hovered` on every hotspot tied to the given index.
    // Pass null/undefined to clear the highlight from all hotspots.
    _setHoveredHotspot(idx) {
      if (!this.hotspotsLayer) return;
      this.hotspotsLayer
        .querySelectorAll(".fp-hotspot.is-hovered")
        .forEach(function (el) {
          el.classList.remove("is-hovered");
        });
      if (idx == null || idx === "") return;
      this._findRelatedHotspotIndices(idx).forEach((hotspotIdx) => {
        const hotspotEl = this.hotspotsLayer.querySelector(
          '[data-fp-hotspot="' + hotspotIdx + '"]',
        );
        if (hotspotEl) hotspotEl.classList.add("is-hovered");
      });
    }

    // Toggles `.is-hovered` on the list item that matches the hotspot index.
    // Pass null/undefined to clear the highlight from all list items.
    _setHoveredListItem(idx) {
      if (!this.list) return;
      this._clearHoveredListItem();
      if (idx == null || idx === "") return;

      let item = this._findListItemForHotspot(idx);
      if (item) {
        this.list.querySelectorAll(".fp-product").forEach(function (el) {
          el.classList.remove("is-active");
        });
        item.classList.add("is-active", "is-hovered");
        item.dataset.fpHoverActive = "true";
        item.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    _clearHoveredListItem() {
      this.list
        .querySelectorAll(".fp-product.is-hovered")
        .forEach(function (el) {
          el.classList.remove("is-hovered");
        });
      this.list
        .querySelectorAll(".fp-product[data-fp-hover-active]")
        .forEach(function (el) {
          el.classList.remove("is-active");
          delete el.dataset.fpHoverActive;
        });
      if (this.activeIndex >= 0) {
        let activeItem = this._findListItemForHotspot(this.activeIndex);
        if (activeItem) activeItem.classList.add("is-active");
      }
    }

    _showPopup(idx) {
      idx = Number(idx);
      let hotspot = this.hotspots[idx];
      if (!hotspot || !this.tooltip) return;

      let product = this._findProduct(hotspot.product_sku);
      let productPrice = product ? formatPrice(product) : "";
      let hasDiagramDescription =
        hotspot.diagram_description != null &&
        hotspot.diagram_description !== "";
      let hasDiagramQty =
        hotspot.diagram_qty != null && hotspot.diagram_qty !== "";
      if (!product && !hasDiagramDescription && !hasDiagramQty) {
        this._hidePopup();
        return;
      }

      this.popupIndex = idx;
      this.tooltip.innerHTML =
        '<button type="button" class="fp-tooltip__close" data-fp-popup-close aria-label="Close">&times;</button>' +
        (product
          ? '<img class="fp-tooltip__image" src="' +
            esc(getImage(product)) +
            '" alt="">'
          : "") +
        (product
          ? '<div class="fp-tooltip__title">' +
            esc(getTitle(product)) +
            "</div>"
          : "") +
        (hasDiagramDescription || hasDiagramQty
          ? '<div class="fp-tooltip__diagram">' +
            (hasDiagramQty
              ? '<div class="fp-tooltip__qty">QTY: ' +
                esc(hotspot.diagram_qty) +
                "</div>"
              : "") +
            (hasDiagramDescription
              ? '<div class="fp-tooltip__description">' +
                esc(hotspot.diagram_description) +
                "</div>"
              : "") +
            "</div>"
          : "") +
        (productPrice
          ? '<div class="fp-tooltip__price">' + productPrice + "</div>"
          : "") +
        (product
          ? '<div class="fp-tooltip__actions">' +
            this._buildProductActionsHTML(product, this._isInCart(product)) +
            "</div>" +
            '<div class="fp-product__error fp-tooltip__error"></div>'
          : "");

      if (product) {
        this._bindQuantityControls(this.tooltip);
        const addBtn = this.tooltip.querySelector("[data-fp-add]");
        if (addBtn) {
          addBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            this._addToCart(product, this.tooltip);
          });
        }
        const removeBtn = this.tooltip.querySelector("[data-fp-remove]");
        if (removeBtn) {
          removeBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            this._removeFromCart(product, this.tooltip);
          });
        }
        const actions = this.tooltip.querySelector(".fp-tooltip__actions");
        if (actions)
          actions.addEventListener("click", (e) => e.stopPropagation());

        const sidebarItem = this._findListItemForHotspot(idx);
        const sidebarError =
          sidebarItem && sidebarItem.querySelector(".fp-product__error");
        const popupError = this.tooltip.querySelector(".fp-product__error");
        if (popupError && sidebarError && sidebarError.textContent) {
          popupError.textContent = sidebarError.textContent;
        }
      }

      this.tooltip.classList.add("is-visible");
      this.tooltip.setAttribute("aria-hidden", "false");
      this._positionPopupByIndex(idx);
    }

    _positionPopupByIndex(idx) {
      if (!this.tooltip || !this.imageWrapper || !this.hotspotsLayer) return;
      let hotspotEl = this.hotspotsLayer.querySelector(
        '[data-fp-hotspot="' + idx + '"]',
      );
      if (!hotspotEl) return;
      this._positionPopup(hotspotEl);
    }

    _positionPopup(hotspotEl) {
      if (!this.tooltip || !this.imageWrapper) return;
      let wrapperRect = this.imageWrapper.getBoundingClientRect();
      let hotspotRect = hotspotEl.getBoundingClientRect();
      let x = hotspotRect.left - wrapperRect.left + hotspotRect.width / 2;
      let y = hotspotRect.top - wrapperRect.top + hotspotRect.height / 2;
      let ttW = this.tooltip.offsetWidth;
      let ttH = this.tooltip.offsetHeight;
      let pad = 14;
      let dx = x + pad + ttW > wrapperRect.width ? x - pad - ttW : x + pad;
      let dy = y + pad + ttH > wrapperRect.height ? y - pad - ttH : y + pad;
      this.tooltip.style.left = Math.max(0, dx) + "px";
      this.tooltip.style.top = Math.max(0, dy) + "px";
      this.tooltip.style.transform = "none";
    }

    _repositionPopupIfOpen() {
      if (
        this.popupIndex >= 0 &&
        this.tooltip &&
        this.tooltip.classList.contains("is-visible")
      ) {
        this._positionPopupByIndex(this.popupIndex);
      }
    }

    _hidePopup() {
      // Intentionally does not clear the hotspot ring: the active
      // part should stay visually selected until the user picks a
      // different one, not merely because its tooltip was dismissed.
      if (!this.tooltip) return;
      this.popupIndex = -1;
      this.tooltip.classList.remove("is-visible");
      this.tooltip.setAttribute("aria-hidden", "true");
      this.tooltip.innerHTML = "";
    }

    _showCallout() {
      if (!this.callout || this.calloutDismissed) return;
      this.callout.hidden = false;
    }

    _dismissCallout() {
      if (!this.callout || this.calloutDismissed) return;
      this.calloutDismissed = true;
      this.callout.hidden = true;
    }

    /* ----- Quantity ------------------------------------------------------ */

    _buildProductActionsHTML(product, inCart) {
      return (
        '<div class="fp-product__quantity" data-fp-quantity>' +
        '<button type="button" class="fp-product__quantity-button" data-fp-quantity-minus aria-label="Decrease quantity" disabled>-</button>' +
        '<input class="fp-product__quantity-input" data-fp-quantity-input type="number" inputmode="numeric" min="1" step="1" value="1" aria-label="Quantity">' +
        '<button type="button" class="fp-product__quantity-button" data-fp-quantity-plus aria-label="Increase quantity">+</button>' +
        "</div>" +
        `<div class="fp-product__buttons ${inCart ? "grouped" : ""} "` +
        ">" +
        '<button type="button" class="fp-product__add" data-fp-add>' +
        (inCart ? "Add more" : "Add to cart") +
        "</button>" +
        '<button type="button" class="fp-product__remove" data-fp-remove aria-label="Remove from cart"' +
        (inCart ? "" : " hidden") +
        ">" +
        "Remove" +
        REMOVE_SVG +
        "</button>" +
        "</div>"
      );
    }

    _bindQuantityControls(container) {
      const input = container.querySelector("[data-fp-quantity-input]");
      const minus = container.querySelector("[data-fp-quantity-minus]");
      const plus = container.querySelector("[data-fp-quantity-plus]");
      if (!input || !minus || !plus) return;

      minus.addEventListener("click", () => {
        this._setContainerQuantity(
          container,
          this._getContainerQuantity(container) - 1,
        );
      });
      plus.addEventListener("click", () => {
        this._setContainerQuantity(
          container,
          this._getContainerQuantity(container) + 1,
        );
      });
      input.addEventListener("change", () => {
        this._setContainerQuantity(container, input.value);
      });
      input.addEventListener("blur", () => {
        this._setContainerQuantity(container, input.value);
      });

      this._setContainerQuantity(container, 1);
    }

    _getContainerQuantity(container) {
      const input = container.querySelector("[data-fp-quantity-input]");
      return normalizeAddQuantity(input && input.value);
    }

    _setContainerQuantity(container, value) {
      const input = container.querySelector("[data-fp-quantity-input]");
      const minus = container.querySelector("[data-fp-quantity-minus]");
      const qty = normalizeAddQuantity(value);
      if (input) input.value = String(qty);
      if (minus) minus.disabled = qty <= 1;
      return qty;
    }

    /* ----- Zoom ---------------------------------------------------------- */

    _prepareZoomForNewImage() {
      this.zoom = 1;
      this.baseImageWidth = 0;
      this.calloutDismissed = false;
      if (this.callout) this.callout.hidden = true;
      this._stopZoomDrag();
      if (this.imageArea) {
        this.imageArea.classList.remove("is-zoomed");
        this.imageArea.scrollLeft = 0;
        this.imageArea.scrollTop = 0;
      }
      if (this.imageWrapper) {
        this.imageWrapper.classList.remove("is-zoom-ready");
        this.imageWrapper.style.width = "";
      }
      if (this.image) {
        this.image.style.width = "";
        this.image.style.maxWidth = "";
        this.image.style.maxHeight = "";
      }
      if (this.zoomControls) this.zoomControls.hidden = true;
      this._updateZoomControls();
      this._updateZoomControlsPosition();
    }

    _initZoom() {
      if (!this.image || !this.imageWrapper) return;
      const rect = this.image.getBoundingClientRect();
      this.baseImageWidth = rect.width;
      if (!(this.baseImageWidth > 0)) return;

      this.imageWrapper.classList.add("is-zoom-ready");
      this.image.style.width = "100%";
      this.image.style.maxWidth = "none";
      this.image.style.maxHeight = "none";
      if (this.zoomControls) this.zoomControls.hidden = false;
      this._applyZoom(false);
    }

    _setZoom(value) {
      if (!this.baseImageWidth) return;
      const nextZoom = Math.max(
        this.zoomMin,
        Math.min(this.zoomMax, Number(value) || 1),
      );
      if (nextZoom === this.zoom) return;
      this.zoom = nextZoom;
      this._applyZoom(true);
    }

    _applyZoom(keepCenter) {
      if (!this.imageWrapper || !this.baseImageWidth) {
        this._updateZoomControls();
        return;
      }

      // Returning to 100% uses centered flex alignment, so clear pan offsets.
      if (this.zoom <= 1 && this.imageArea) {
        this.imageArea.scrollLeft = 0;
        this.imageArea.scrollTop = 0;
      }

      let centerX = 0;
      let centerY = 0;
      let prevWidth = this.imageWrapper.offsetWidth || this.baseImageWidth;
      let prevHeight = this.imageWrapper.offsetHeight || 0;
      if (keepCenter && this.imageArea) {
        centerX =
          (this.imageArea.scrollLeft + this.imageArea.clientWidth / 2) /
          prevWidth;
        centerY = prevHeight
          ? (this.imageArea.scrollTop + this.imageArea.clientHeight / 2) /
            prevHeight
          : 0;
      }

      this.imageWrapper.style.width =
        Math.round(this.baseImageWidth * this.zoom) + "px";
      if (this.imageArea)
        this.imageArea.classList.toggle("is-zoomed", this.zoom > 1);
      this._updateZoomControls();
      this._updateZoomControlsPosition();

      if (keepCenter && this.imageArea) {
        const nextWidth = this.imageWrapper.offsetWidth;
        const nextHeight = this.imageWrapper.offsetHeight;
        this.imageArea.scrollLeft = Math.max(
          0,
          centerX * nextWidth - this.imageArea.clientWidth / 2,
        );
        this.imageArea.scrollTop = Math.max(
          0,
          centerY * nextHeight - this.imageArea.clientHeight / 2,
        );
        this._updateZoomControlsPosition();
      }
      this._repositionPopupIfOpen();
    }

    _updateZoomControls() {
      const pct = Math.round(this.zoom * 100) + "%";
      if (this.zoomResetBtn) this.zoomResetBtn.textContent = pct;
      if (this.zoomOutBtn) this.zoomOutBtn.disabled = this.zoom <= this.zoomMin;
      if (this.zoomInBtn) this.zoomInBtn.disabled = this.zoom >= this.zoomMax;
    }

    _updateZoomControlsPosition() {
      if (!this.imageArea) return;
      this.imageArea.style.setProperty(
        "--fp-scroll-left",
        this.imageArea.scrollLeft + "px",
      );
      this.imageArea.style.setProperty(
        "--fp-scroll-top",
        this.imageArea.scrollTop + "px",
      );
    }

    _onZoomDragStart(e) {
      if (!this.imageArea || this.zoom <= 1) return;
      if (e.button !== 0) return;
      if (e.target.closest(".fp-hotspot, .fp-zoom-controls, button, input, a"))
        return;

      this.isDraggingZoom = true;
      this.zoomDragStartX = e.clientX;
      this.zoomDragStartY = e.clientY;
      this.zoomStartScrollLeft = this.imageArea.scrollLeft;
      this.zoomStartScrollTop = this.imageArea.scrollTop;
      this.imageArea.classList.add("is-dragging");

      document.addEventListener("mousemove", this._boundZoomDragMove);
      document.addEventListener("mouseup", this._boundZoomDragEnd);
      e.preventDefault();
    }

    _onZoomDragMove(e) {
      if (!this.isDraggingZoom || !this.imageArea) return;
      const deltaX = e.clientX - this.zoomDragStartX;
      const deltaY = e.clientY - this.zoomDragStartY;
      this.imageArea.scrollLeft = this.zoomStartScrollLeft - deltaX;
      this.imageArea.scrollTop = this.zoomStartScrollTop - deltaY;
    }

    _onZoomDragEnd() {
      this._stopZoomDrag();
    }

    _stopZoomDrag() {
      if (!this.isDraggingZoom && !this.imageArea) return;
      this.isDraggingZoom = false;
      if (this.imageArea) this.imageArea.classList.remove("is-dragging");
      document.removeEventListener("mousemove", this._boundZoomDragMove);
      document.removeEventListener("mouseup", this._boundZoomDragEnd);
    }

    /* ----- Cart ---------------------------------------------------------- */

    async _fetchCartKeys() {
      try {
        let res = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
        });
        if (!res.ok) return { keys: new Set(), lineKeys: new Map() };
        let cart = await res.json();
        let keys = new Set();
        let lineKeys = new Map();
        (cart.items || []).forEach(function (item) {
          [
            item.id,
            item.variant_id,
            item.product_id,
            item.sku,
            item.handle,
          ].forEach(function (id) {
            if (id == null || id === "") return;
            let key = String(id);
            keys.add(key);
            if (item.key) lineKeys.set(key, item.key);
          });
        });
        return { keys, lineKeys };
      } catch (e) {
        return { keys: new Set(), lineKeys: new Map() };
      }
    }

    async _addToCart(product, container) {
      const variant = getVariantNodes(product)[0];
      const variantId = normalizeVariantId(variant && variant.id);
      const btn = container.querySelector("[data-fp-add]");
      const quantity = this._getContainerQuantity(container);
      this._clearProductError(product);
      if (!variantId) {
        console.warn("[fitting-parts] no variant id for product", product);
        this._setProductError(product, "This product is unavailable.");
        this._findProductContainers(product).forEach((item) => {
          const itemBtn = item.querySelector("[data-fp-add]");
          if (itemBtn) {
            itemBtn.disabled = true;
            itemBtn.textContent = "Unavailable";
          }
        });
        return;
      }
      if (!btn) return;
      let origText = btn.textContent;
      this._findProductContainers(product).forEach((item) => {
        const itemBtn = item.querySelector("[data-fp-add]");
        const itemRemoveBtn = item.querySelector("[data-fp-remove]");
        if (itemBtn) {
          itemBtn.disabled = true;
          itemBtn.textContent = "Adding…";
        }
        if (itemRemoveBtn) itemRemoveBtn.disabled = true;
      });

      try {
        let url =
          (window.routes && window.routes.cart_add_url) || "/cart/add.js";
        let formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", String(quantity));

        let res = await fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        });
        if (!res.ok) {
          let data = await res.json().catch(function () {
            return null;
          });
          throw new Error(getCartErrorMessage(data));
        }

        let addedItem = await res.json().catch(function () {
          return null;
        });
        getProductKeys(product).forEach((v) => {
          this.cartKeys.add(v);
          if (addedItem && addedItem.key)
            this.cartLineKeys.set(v, addedItem.key);
        });
        this._syncProductCartState(product, true);
        this._refreshCartUI();
      } catch (err) {
        console.error("error", err);
        this._setProductError(product, getCartErrorMessage(err));
        this._findProductContainers(product).forEach((item) => {
          const itemBtn = item.querySelector("[data-fp-add]");
          const itemRemoveBtn = item.querySelector("[data-fp-remove]");
          if (itemBtn) {
            itemBtn.disabled = false;
            itemBtn.textContent = origText || "Add to cart";
          }
          if (itemRemoveBtn) itemRemoveBtn.disabled = false;
        });
      }
    }

    async _removeFromCart(product, container) {
      const productKeys = getProductKeys(product);
      const variant = getVariantNodes(product)[0];
      const variantId = normalizeVariantId(variant && variant.id);
      let lineId = "";
      for (let i = 0; i < productKeys.length; i++) {
        if (this.cartLineKeys.has(productKeys[i])) {
          lineId = this.cartLineKeys.get(productKeys[i]);
          break;
        }
      }
      if (!lineId) lineId = variantId;

      this._clearProductError(product);
      if (!lineId) {
        this._setProductError(
          product,
          "Unable to find this item in your cart.",
        );
        return;
      }

      const containers = this._findProductContainers(product);
      containers.forEach((item) => {
        const addBtn = item.querySelector("[data-fp-add]");
        const removeBtn = item.querySelector("[data-fp-remove]");
        if (addBtn) addBtn.disabled = true;
        if (removeBtn) removeBtn.disabled = true;
      });

      try {
        let url =
          (window.routes && window.routes.cart_change_url) || "/cart/change.js";
        let res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: lineId, quantity: 0 }),
        });
        if (!res.ok) {
          let data = await res.json().catch(function () {
            return null;
          });
          throw new Error(getCartErrorMessage(data));
        }

        productKeys.forEach((v) => {
          this.cartKeys.delete(v);
          this.cartLineKeys.delete(v);
        });
        this._syncProductCartState(product, false);
        this._refreshCartUI();
        this._fetchCartKeys().then((cartState) => {
          this.cartKeys = cartState.keys;
          this.cartLineKeys = cartState.lineKeys;
        });
      } catch (err) {
        console.error("error", err);
        this._setProductError(product, getCartErrorMessage(err));
        containers.forEach((item) => {
          const addBtn = item.querySelector("[data-fp-add]");
          const removeBtn = item.querySelector("[data-fp-remove]");
          if (addBtn) addBtn.disabled = false;
          if (removeBtn) removeBtn.disabled = false;
        });
      }
    }

    _findProductContainers(product) {
      const containers = [];
      const productKeys = getProductKeys(product);
      if (!productKeys.length) return containers;

      this.list.querySelectorAll(".fp-product").forEach((item) => {
        if (getDatasetKeys(item).some((key) => productKeys.includes(key))) {
          containers.push(item);
        }
      });

      if (
        this.popupIndex >= 0 &&
        this.tooltip &&
        this.tooltip.classList.contains("is-visible")
      ) {
        const popupHotspot = this.hotspots[this.popupIndex];
        const popupProduct =
          popupHotspot && this._findProduct(popupHotspot.product_sku);
        const popupKeys = getProductKeys(popupProduct);
        if (popupKeys.some((key) => productKeys.includes(key))) {
          containers.push(this.tooltip);
        }
      }

      return containers;
    }

    _setProductError(product, message) {
      this._findProductContainers(product).forEach((container) => {
        const errorEl = container.querySelector(".fp-product__error");
        if (errorEl) errorEl.textContent = message;
      });
      if (this.popupIndex >= 0) {
        this._positionPopupByIndex(this.popupIndex);
      }
    }

    _clearProductError(product) {
      this._findProductContainers(product).forEach((container) => {
        const errorEl = container.querySelector(".fp-product__error");
        if (errorEl) errorEl.textContent = "";
      });
    }

    _syncProductCartState(product, inCart) {
      const productKeys = getProductKeys(product);
      this._clearProductError(product);

      this.list.querySelectorAll(".fp-product").forEach((item) => {
        const matchesProduct = getDatasetKeys(item).some((key) =>
          productKeys.includes(key),
        );
        if (!matchesProduct) return;
        item.classList.toggle("fp-product--in-cart", inCart);
        const itemBtn = item.querySelector("[data-fp-add]");
        if (itemBtn) {
          console.log("itemBtn", itemBtn);
          const parentBtnGroup = itemBtn.parentElement;
          if (parentBtnGroup) {
            parentBtnGroup.classList.toggle("grouped", inCart);
          }
          itemBtn.disabled = false;
          itemBtn.textContent = inCart ? "Add more" : "Add to cart";
        }
        const itemRemoveBtn = item.querySelector("[data-fp-remove]");
        if (itemRemoveBtn) {
          itemRemoveBtn.disabled = false;
          itemRemoveBtn.hidden = !inCart;
        }
        this._setContainerQuantity(item, 1);
      });

      this._findHotspotIndicesForProduct(product).forEach((hotspotIdx) => {
        let el = this.hotspotsLayer.querySelector(
          '[data-fp-hotspot="' + hotspotIdx + '"]',
        );
        if (el) el.classList.toggle("fp-hotspot--in-cart", inCart);
      });

      if (this.popupIndex >= 0) {
        const popupHotspot = this.hotspots[this.popupIndex];
        const popupProduct =
          popupHotspot && this._findProduct(popupHotspot.product_sku);
        const popupKeys = getProductKeys(popupProduct);
        const popupMatchesProduct = popupKeys.some((key) =>
          productKeys.includes(key),
        );
        if (popupMatchesProduct) {
          const popupBtn = this.tooltip.querySelector("[data-fp-add]");
          if (popupBtn) {
            const parentBtnGroup = popupBtn.parentElement;
            if (parentBtnGroup) {
              parentBtnGroup.classList.toggle("grouped", inCart);
            }
            popupBtn.disabled = false;
            popupBtn.textContent = inCart ? "Add more" : "Add to cart";
          }
          const popupRemoveBtn = this.tooltip.querySelector("[data-fp-remove]");
          if (popupRemoveBtn) {
            popupRemoveBtn.disabled = false;
            popupRemoveBtn.hidden = !inCart;
          }
          this._setContainerQuantity(this.tooltip, 1);
        }
      }
    }

    _refreshCartUI() {
      // Best-effort refresh of cart-icon-bubble and cart-drawer sections.
      fetch("/?sections=cart-icon-bubble,cart-drawer", {
        headers: { Accept: "application/json" },
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (sections) {
          if (!sections) return;
          let parser = new DOMParser();
          if (sections["cart-icon-bubble"]) {
            let bubbleDoc = parser.parseFromString(
              sections["cart-icon-bubble"],
              "text/html",
            );
            document
              .querySelectorAll("#cart-icon-bubble")
              .forEach(function (target) {
                let fresh = bubbleDoc.querySelector("#cart-icon-bubble");
                if (fresh) target.innerHTML = fresh.innerHTML;
              });
          }
          if (sections["cart-drawer"]) {
            let drawerDoc = parser.parseFromString(
              sections["cart-drawer"],
              "text/html",
            );
            document.querySelectorAll("cart-drawer").forEach(function (target) {
              let fresh = drawerDoc.querySelector("cart-drawer");
              if (fresh) target.innerHTML = fresh.innerHTML;
            });
          }
          document.dispatchEvent(new CustomEvent("cart:updated"));
        })
        .catch(function () {
          /* silent */
        });
    }

    /* ----- Helpers ------------------------------------------------------- */

    _findListItemForHotspot(idx) {
      let hotspot = this.hotspots[Number(idx)];
      if (!hotspot) return null;
      return this._findListItem(hotspot.product_sku);
    }

    _findHotspotIndicesForProduct(product) {
      let productKeys = getProductKeys(product);
      if (!productKeys.length) return [];
      return this.hotspots.reduce(function (indices, h, idx) {
        if (
          h.product_sku != null &&
          productKeys.includes(String(h.product_sku))
        ) {
          indices.push(idx);
        }
        return indices;
      }, []);
    }

    _findRelatedHotspotIndices(idx) {
      let hotspotIdx = Number(idx);
      let hotspot = this.hotspots[hotspotIdx];
      if (!hotspot) return [];
      if (hotspot.product_sku == null || hotspot.product_sku === "")
        return [hotspotIdx];

      let product = this._findProduct(hotspot.product_sku);
      if (product) {
        let productHotspots = this._findHotspotIndicesForProduct(product);
        if (productHotspots.length) return productHotspots;
      }

      let sku = String(hotspot.product_sku);
      return this.hotspots.reduce(function (indices, h, currentIdx) {
        if (String(h.product_sku) === sku) indices.push(currentIdx);
        return indices;
      }, []);
    }

    _getDiagramQtyForHotspots(indices) {
      for (let i = 0; i < indices.length; i++) {
        let hotspot = this.hotspots[indices[i]];
        let qty = normalizeDiagramQty(hotspot && hotspot.diagram_qty);
        if (qty > 1) return qty;
      }
      return 1;
    }

    _findProduct(sku) {
      if (!sku) return null;
      sku = String(sku);
      return (
        this.products.find(function (p) {
          return getProductKeys(p).includes(sku);
        }) || null
      );
    }

    _findListItem(sku) {
      if (!sku) return null;
      sku = String(sku);
      // Support arbitrary characters in SKU.
      let items = this.list.querySelectorAll(".fp-product");
      for (let i = 0; i < items.length; i++) {
        if (items[i].dataset.sku === sku) return items[i];
        if (getDatasetKeys(items[i]).includes(sku)) return items[i];
      }
      return null;
    }

    _isInCart(product) {
      if (!product) return false;
      let keys = getProductKeys(product);
      for (let i = 0; i < keys.length; i++) {
        if (this.cartKeys.has(keys[i])) return true;
      }
      return false;
    }

    _showLoader(on) {
      this.loader.classList.toggle("is-visible", !!on);
    }
    _showError(on) {
      if (this.errorEl) this.errorEl.hidden = !on;
    }
  }

  customElements.define("fitting-parts-popup", FittingPartsPopup);

  /* ------------------------------------------------------------------------ *
   * Trigger injector — adds a "View diagram" link inside the Fasteners
   * facet item whenever it appears in #assembly-list (the list is populated
   * dynamically by the autocomplete script).
   * ------------------------------------------------------------------------ */

  let TARGET_LABEL = "fasteners";
  let injectedItems = new WeakSet();

  function getItemLabel(item) {
    let direct = item.getAttribute("data-label");
    if (direct) return direct;
    let input = item.querySelector("input[data-label]");
    if (input) return input.getAttribute("data-label");
    let lbl = item.querySelector(".facet-checkbox__label");
    if (lbl) return lbl.textContent.trim();
    return "";
  }

  function getAssemblyId(item) {
    // Prefer explicit data-assembly-id, fall back to the checkbox value/id.
    let explicit = item.getAttribute("data-assembly-id");
    if (explicit) return explicit;
    let input = item.querySelector('input[type="checkbox"]');
    if (input) return input.value || input.id || "";
    return "";
  }

  function injectTrigger(item) {
    if (injectedItems.has(item)) return;
    if (item.querySelector("[data-fitting-parts-trigger]")) {
      injectedItems.add(item);
      return;
    }
    const assemblyId = getAssemblyId(item);
    let a = document.createElement("a");
    a.href = "#";
    a.className = "fp-trigger";
    // a.setAttribute("data-fitting-parts-trigger", "");
    // a.setAttribute("data-assembly-id", assemblyId);
    a.setAttribute("role", "button");
    a.textContent = "View diagram";
    item.appendChild(a);
    injectedItems.add(item);
  }

  function scan(root) {
    let lists = (root || document).querySelectorAll("#assembly-list");
    lists.forEach(function (list) {
      list.querySelectorAll(".facets__item").forEach(function (item) {
        let label = (getItemLabel(item) || "").toLowerCase();
        if (label === TARGET_LABEL) injectTrigger(item);
      });
    });
  }

  function start() {
    // scan(document);
    // let observer = new MutationObserver(function (mutations) {
    //     // Only rescan when something inside an assembly-list changed.
    //     for (let i = 0; i < mutations.length; i++) {
    //         let m = mutations[i];
    //         if (
    //             (m.target && m.target.id === "assembly-list") ||
    //             (m.target && m.target.closest && m.target.closest("#assembly-list")) ||
    //             // Also catch initial creation of #assembly-list itself.
    //             (m.addedNodes && Array.from(m.addedNodes).some(function (n) {
    //                 return n.nodeType === 1 && (n.id === "assembly-list" || (n.querySelector && n.querySelector("#assembly-list")));
    //             }))
    //         ) {
    //             scan(document);
    //             return;
    //         }
    //     }
    // });
    // observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  /* ------------------------------------------------------------------------ *
   * Small utilities
   * ------------------------------------------------------------------------ */

  function pct(n) {
    return Number(n) * 100 + "%";
  }

  function normalizeRadiusPercent(value) {
    const radius = Number(value);
    if (!(radius > 0)) return 0;
    return radius > 0.1 ? radius / 100 : radius;
  }

  function normalizeDiagramQty(value) {
    const qty = Number(value);
    if (!(qty > 1)) return 1;
    return Math.round(qty);
  }

  function normalizeAddQuantity(value) {
    const qty = Number(value);
    if (!(qty > 1)) return 1;
    return Math.round(qty);
  }

  function normalizeVariantId(value) {
    if (value == null) return "";
    let id = String(value);
    return id.indexOf("/") >= 0 ? id.split("/").pop() : id;
  }

  function getCartErrorMessage(err) {
    let message = "";
    if (typeof err === "string") {
      message = err;
    } else if (err && typeof err === "object") {
      message =
        extractErrorMessage(err.errors) ||
        err.description ||
        err.message ||
        err.status ||
        "";
    }
    if (!message || message === "Failed to fetch") {
      return "Unable to add this item to cart. Please try again.";
    }
    return message;
  }

  function extractErrorMessage(errors) {
    if (!errors) return "";
    if (typeof errors === "string") return errors;
    if (Array.isArray(errors))
      return errors.map(extractErrorMessage).filter(Boolean).join(" ");
    if (typeof errors === "object") {
      return Object.keys(errors)
        .map(function (key) {
          return extractErrorMessage(errors[key]);
        })
        .filter(Boolean)
        .join(" ");
    }
    return String(errors);
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getTitle(p) {
    return p.title || p.name || p.handle || p.sku || "Untitled";
  }

  function getImage(p) {
    if (!p) return "";
    if (p.featuredMedia.preview.image.url)
      return p.featuredMedia.preview.image.url;
    return "https://placehold.co/120x120?text=%E2%80%94";
  }

  function getVariantNodes(p) {
    if (!p || !p.variants) return [];
    if (Array.isArray(p.variants)) return p.variants;
    if (Array.isArray(p.variants.nodes)) return p.variants.nodes;
    return [];
  }

  function getVariantSku(p) {
    let variant = getVariantNodes(p).find(function (v) {
      return v && v.sku;
    });
    return variant ? variant.sku : "";
  }

  function getProductKeys(p) {
    if (!p) return [];
    let keys = [p.id, p.variant_id, p.sku, p.handle];
    getVariantNodes(p).forEach(function (v) {
      if (!v) return;
      keys.push(v.id, v.variant_id, v.sku);
    });
    return keys
      .filter(function (key) {
        return key != null && key !== "";
      })
      .map(function (key) {
        return String(key);
      });
  }

  function getDatasetKeys(el) {
    if (!el || !el.dataset.productKeys) return [];
    try {
      let keys = JSON.parse(el.dataset.productKeys);
      return Array.isArray(keys)
        ? keys.map(function (key) {
            return String(key);
          })
        : [];
    } catch (e) {
      return [];
    }
  }

  function getDatasetHotspotIdxs(el) {
    if (!el || !el.dataset.hotspotIdxs) return [];
    try {
      let idxs = JSON.parse(el.dataset.hotspotIdxs);
      return Array.isArray(idxs)
        ? idxs.map(function (idx) {
            return String(idx);
          })
        : [];
    } catch (e) {
      return [];
    }
  }

  function getProductPriceAmount(product) {
    if (!product) return null;

    const variants = getVariantNodes(product);
    const variantPrice = variants[0] && variants[0].price;
    const money =
      product.priceRangeV2 && product.priceRangeV2.minVariantPrice
        ? product.priceRangeV2.minVariantPrice
        : product.priceRange && product.priceRange.minVariantPrice
          ? product.priceRange.minVariantPrice
          : variantPrice && typeof variantPrice === "object"
            ? variantPrice
            : null;

    if (money && money.amount != null) {
      return {
        amount: money.amount,
        currencyCode: money.currencyCode || "USD",
        isCents: false,
      };
    }

    if (variantPrice != null) {
      return { amount: variantPrice, currencyCode: "USD", isCents: true };
    }

    if (product.price != null) {
      return { amount: product.price, currencyCode: "USD", isCents: true };
    }

    return null;
  }

  function formatPrice(product) {
    const price = getProductPriceAmount(product);
    if (!price) return "";
    if (
      typeof price.amount === "string" &&
      /[A-Za-z$€£¥₴]/.test(price.amount)
    ) {
      return esc(price.amount);
    }

    const amount = Number(price.amount);
    if (!Number.isFinite(amount)) return "";
    const cents = price.isCents ? Math.round(amount) : Math.round(amount * 100);
    let fmt = window.theme && window.theme.moneyFormat;
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === "function" &&
      fmt
    ) {
      try {
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) {
        /* fallthrough */
      }
    }
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: price.currencyCode || "USD",
      }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }
})();
